export var ErrorCode;
(function (ErrorCode) {
    ErrorCode[ErrorCode["ServerError"] = 500] = "ServerError";
    ErrorCode[ErrorCode["SessionExpire"] = 440] = "SessionExpire";
    ErrorCode[ErrorCode["Authentication"] = 401] = "Authentication";
    ErrorCode[ErrorCode["BadRequest"] = 400] = "BadRequest";
    ErrorCode[ErrorCode["AccessDenied"] = 403] = "AccessDenied";
    ErrorCode[ErrorCode["Socket_Close_Abnormal"] = 1006] = "Socket_Close_Abnormal";
})(ErrorCode || (ErrorCode = {}));
